/**
 * @param {string} ISODateString - ISO format Date value in string.
 */
export function dateWithoutHourFormat(ISODateString) {
  if (!ISODateString) return '-';
  const dueDate = new Date(ISODateString);
  const day = dueDate.getDate().toString().padStart(2, '0');
  const month = (dueDate.getMonth() + 1).toString().padStart(2, '0');
  const year = dueDate.getFullYear().toString().substring(2, 4);
  return `${day}/${month}/${year}`;
}
